"use client";

import type { PayoutsSessionElements } from "@whop/embedded-components-vanilla-js/types";

import { createWithFallback } from "../lib/create-with-fallback";
import { usePayoutsSession } from "./session";

export type {
	WithFallbackPropsOptional,
	WithFallbackPropsRequired,
} from "../lib/create-with-fallback";

export const withFallback =
	createWithFallback<PayoutsSessionElements>(usePayoutsSession);
